import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function cpfCnpjValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null; // Campo vazio é tratado pelo Validators.required

    // Remove caracteres de formatação (pontos, traços, barras, espaços)
    const raw = value.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');

    if (raw.length === 11) {
      return validarCPF(raw) ? null : { cpfInvalido: true };
    }

    if (raw.length === 14) {
      return validarCnpjAlfanumerico(raw) ? null : { cnpjInvalido: true };
    }

    return { tamanhoInvalido: true };
  };
}

// ==========================================
// VALIDAÇÃO DE CPF
// ==========================================
function validarCPF(cpf: string): boolean {
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0;
  let resto: number;

  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.substring(i - 1, i), 10) * (11 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(9, 10), 10)) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.substring(i - 1, i), 10) * (12 - i);
  }
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.substring(10, 11), 10)) return false;

  return true;
}

// ==========================================
// VALIDAÇÃO DE CNPJ ALFANUMÉRICO
// ==========================================
function validarCnpjAlfanumerico(cnpj: string): boolean {
  // Os últimos 2 dígitos (DV1 e DV2) DEVEM ser numéricos
  if (!/^\d{2}$/.test(cnpj.substring(12, 14))) {
    return false;
  }

  const pesosDV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosDV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  // Valida 1º Dígito Verificador
  const dv1 = calcularDigitoCnpj(cnpj.substring(0, 12), pesosDV1);
  if (dv1 !== parseInt(cnpj.charAt(12), 10)) {
    return false;
  }

  // Valida 2º Dígito Verificador
  const dv2 = calcularDigitoCnpj(cnpj.substring(0, 13), pesosDV2);
  if (dv2 !== parseInt(cnpj.charAt(13), 10)) {
    return false;
  }

  return true;
}

function calcularDigitoCnpj(base: string, pesos: number[]): number {
  let soma = 0;

  for (let i = 0; i < base.length; i++) {
    const char = base.charAt(i);
    // Tabela ASCII: '0'-'9' -> 48 a 57 | 'A'-'Z' -> 65 a 90
    // O valor numérico é sempre (Código ASCII - 48)
    const valorNum = char.charCodeAt(0) - 48;
    soma += valorNum * pesos[i];
  }

  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}